<div>
  <div class="mt-4">
       <!-- <form-client-search
          [search]="inputSearchClient"
          [listSearch]="listSearch"
          
        /> -->

    <!-- @if (checkPermission('pesquisar-paginado')) {
         <form-search [search]="inputSearch" (responseSearch)="search($event)" />
    } -->
    <div>
      @if (!loading) {
        <div>
          <table-list-simple
            [dataSource]="itemsList"
            [columns]="columns"
            (selectItem)="editItem($event)"
            (deleteItem)="deleteItem($event)"
          />
          @if (itemsList.length > 0) {
            <pagination
              [currentPage]="page"
              [pageSize]="rows"
              [totalRecords]="numberRows"
              (pageChanged)="pageChanged($event)"
            />
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</div>
